<template>
    <div class="map">
        <single-map v-if="content !== null && addressObj !== null " class="map-container" :content="content" :addressObj="addressObj" style="height:586px!important;"></single-map>
    </div>


</template>

<script>

    export default {
        name: 'DetailMap',
        components: {
            SingleMap: () => import('@/components/map/single.vue'),
        },
        props: {
          height: {
            type: String,
            default: '700px',
        },
        content: {
            type: Object,
            required: true,
            default: {},
        },
        addressObj: {
            type: Object,
            default: {},
        },
    },
}
</script>

<style lang="scss" scoped>

    .map {
        box-shadow: 1px 2px 10px 1px #00000040;

        @media (max-width: 991px) {
            display: none;
        }
    }

</style>
